import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ReminderAnalyticsQuery, ReminderSnapshotResponse, ReminderDistributionResponse, ReminderTrendsResponse } from './reminder-analytics.model';
import { ReminderAnalyticsService } from './reminder-analytics.abstract.service';

@Injectable({
    providedIn: 'root',
})
export class ReminderAnalyticsImplService implements ReminderAnalyticsService {
    private baseUrl = `${environment.API_GATEWAY_URL}/reminder/admin/analytics`;

    constructor(@Inject('HTTP_CLIENT') public http: HttpClient) {}

    getSnapshot(query: ReminderAnalyticsQuery): Observable<ReminderSnapshotResponse> {
        return this.http.get<ReminderSnapshotResponse>(`${this.baseUrl}/snapshot`, {
            params: this.buildParams(query),
        });
    }

    getDistribution(query: ReminderAnalyticsQuery): Observable<ReminderDistributionResponse> {
        return this.http.get<ReminderDistributionResponse>(`${this.baseUrl}/distribution`, {
            params: this.buildParams(query),
        });
    }

    getTrends(query: ReminderAnalyticsQuery): Observable<ReminderTrendsResponse> {
        return this.http.get<ReminderTrendsResponse>(`${this.baseUrl}/trends`, {
            params: this.buildParams(query),
        });
    }

    private buildParams(query: ReminderAnalyticsQuery): HttpParams {
        let params = new HttpParams();

        if (query.period) {
            params = params.set('period', query.period);
        }
        if (query.from) {
            params = params.set('from', query.from);
        }
        if (query.to) {
            params = params.set('to', query.to);
        }
        if (query.comparePrevious) {
            params = params.set('comparePrevious', 'true');
        }
        if (query.channels) {
            params = params.set('channels', query.channels);
        }
        if (query.collectIds) {
            params = params.set('collectIds', query.collectIds);
        }
        if (query.areaIds) {
            params = params.set('areaIds', query.areaIds);
        }

        return params;
    }
}

export const REMINDER_ANALYTICS_SERVICE_PROVIDER = {
    provide: ReminderAnalyticsService,
    useClass: ReminderAnalyticsImplService,
};
